<div (click)="cart == 'cart_sidebar' && cartToggle(true)">
  <i class="ri-shopping-cart-line"></i>
</div>
@if ((shoppingCart$ | async)?.items?.length) {
<span class="cart_qty_cls">{{ (shoppingCart$ | async)?.items?.length }}</span>
}
<!-- Add to cart bar -->
<div [class.open-side]="shoppingCartService.sideBarOpen" [ngClass]="{
    'add_to_cart right right-cart-box': cart == 'cart_sidebar',
    'show-div shopping-cart': cart == 'cart_mini',
  }" id="cart_side">
  <a (click)="cartToggle(false)" class="overlay" href="javascript:void(0)"></a>
  <div class="cart-inner">
    <div class="cart_top">
      <h3>
        {{ "my_cart" | translate }}
        <span>({{ (shoppingCart$ | async)?.items?.length }})</span>
      </h3>
      @if (cart == "cart_sidebar") {
      <div class="close-cart">
        <a href="javascript:void(0)" (click)="cartToggle(false)">
          <i class="ri-close-fill"></i>
        </a>
      </div>
      }
    </div>

    <div [class.empty-cart]="!(shoppingCart$ | async)?.items?.length" class="cart_media">
      <ul class="cart_product">
        @for (item of (shoppingCart$ | async)?.items; track item) {
        <li [class.stock-issue]="item.has_stock_issue">
          <div class="media">
            <a href="javascript:void(0)">
              <img [src]="
                    item?.multimedia && item?.multimedia?.url
                      ? item.multimedia.url
                      : '/assets/images/placeholder/product.png'
                  " (error)="handleImageError($event)" appImageFallback class="" [alt]="item?.title" />
            </a>
            <div class="media-body">
              <a href="javascript:void(0)">
                <h4>{{ item?.title }}</h4>
              </a>
              <h4 class="quantity">
                <span>{{ item?.quantity }} x {{ item.price.sale_price }} {{ getCurrency() }}</span>
              </h4>
              @if (item?.variant_option_value) {
              <h5 class="gram">
                {{ formatVariantOptions(item?.variant_option_value) }}
              </h5>
              }
              <div class="cart-item-controls">
                <div class="qty-box">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <app-button [type]="'button'" [class]="'btn quantity-left-minus'" [id]="
                            'add-to-cart' + item.id + item.quantity + item.sku_id
                          " (click)="updateQuantity(item, -1)" [spinner]="false">
                        @if (item.quantity > 1) {
                        <i class="ri-subtract-line"></i>
                        }
                        @if (item.quantity <= 1) { <i class="ri-delete-bin-line"></i>
                          }
                      </app-button>
                    </span>
                    <input class="form-control input-number qty-input" [class.qty-error]="item.has_stock_issue"
                      type="number" name="quantity" [value]="item?.quantity" readonly />
                    <span class="input-group-prepend">
                      <app-button [type]="'button'" [class]="'btn quantity-right-plus'" [id]="
                            'qty-left-minus' +
                            item.id +
                            item.quantity +
                            item.sku_id
                          " (click)="updateQuantity(item, 1)" [spinner]="false">
                        <i class="ri-add-line"></i>
                      </app-button>
                    </span>
                  </div>
                </div>
                <div class="close-circle">
                  <app-button [class]="'delete-button close_button'" [id]="
                        'cart_item_delete_btn' +
                        item.id +
                        item.quantity +
                        item.sku_id
                      " [spinner]="false" [iconClass]="'ri-delete-bin-line'" (click)="delete(item)">
                  </app-button>
                </div>
              </div>
            </div>
          </div>
          @if (item.has_stock_issue) {
          <div class="stock-warning">
            <i class="ri-error-warning-line"></i>
            <span>{{ 'only_x_available' | translate: { count: item.available_stock } }}</span>
          </div>
          }
        </li>

        } @empty {

        <div class="empty-cart-box">
          <div>
            <i class="ri-shopping-cart-line"></i>
            <h5>{{ "no_cart_item_desccription" | translate }}</h5>
          </div>
        </div>
        }
      </ul>
      @if ((shoppingCart$ | async)?.items?.length) {
      <ul class="cart_total">
        <li>
          <div class="total">
            <h5>
              {{ "subtotal" | translate }} :
              <span>{{ (shoppingCart$ | async)?.total_price?.sale_price }} {{ getCurrency() }}</span>
            </h5>
          </div>
        </li>
        @if (hasStockIssues) {
        <li>
          <div class="stock-error-message">
            <i class="ri-error-warning-fill"></i>
            <span>{{ 'adjust_quantities_to_checkout' | translate }}</span>
          </div>
        </li>
        }
        <li>
          <div class="buttons">
            <a href="javascript:void(0)" class="btn view-cart" [routerLink]="['/cart']" (click)="cartToggle(false)">{{
              "view_cart" | translate }}</a>
            <a href="javascript:void(0)" class="btn checkout" [class.disabled]="hasStockIssues"
              [routerLink]="hasStockIssues ? null : ['/checkout']" (click)="!hasStockIssues && cartToggle(false)">{{
              "checkout" | translate }}</a>
          </div>
        </li>
      </ul>
      }

    </div>
  </div>
</div>
<!-- Add to cart bar end-->